import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Breadcrumb from "@/components/specific/Breadcrumb";
import Steps from "@/components/common/Steps";

import { selectCurrentStep } from "@/store/redux/slices/event/sub_event_slice";

const AddSubEventLayout = () => {
  const steps = [
    { title: "Sub Event Information" },
    { title: "Schedules" },
    { title: "Logistics and Budget" },
  ];

  const currentStep = useSelector(selectCurrentStep);

  // breadcrumb
  const breadcrumbItems = [
    { title: "Events", link: "/dashboard/events" },
    { title: "Add Sub Event", link: "" },
  ];

  return (
    <div className="w-full py-6 text-left lg:grid lg:grid-cols-4 lg:gap-10 sm:py-0">
      {/* Mobile Steps - showing all step circles but only active step title */}
      <div className="mb-6 lg:hidden">
        <Steps current={currentStep - 1} steps={steps} />
      </div>

      {/* Main Content Area */}
      <div className="col-span-3  lg:border-r">
        <Breadcrumb items={breadcrumbItems} />
        <Outlet />
      </div>

      {/* Desktop Steps - vertical layout showing all steps */}
      <div className="hidden lg:block mt-10 sticky top-[74px] h-[90vh]">
        <Steps current={currentStep - 1} steps={steps} />
      </div>
    </div>
  );
};

export default AddSubEventLayout;
